export default __webpack_public_path__ + "static/media/Anton.c407103b.ttf";